import React, { FunctionComponent, useEffect } from "react";
import { createPortal } from "react-dom";
import Theme from "../../../theme/theme";
import {
  StyledModalBackdrop,
  StyledModalWrapper,
  StyledModalContent,
  StyledModalTitle,
} from "./styles";

export interface ModalProps {
  /**
   * Function used to close the modal
   */
  closeFunction?: () => void;
  /**
   * Modal title to be displayed in the modal header
   */
  title?: string;
  maxWidth?: string;
  dataTestId?: string | undefined;
}

export const Modal: FunctionComponent<ModalProps> = ({
  children,
  title,
  closeFunction,
  maxWidth,
  dataTestId,
}) => {
  const closeByEsc = (event: KeyboardEvent): void => {
    if (event.which === 27 && !!closeFunction) {
      closeFunction();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", closeByEsc);

    return () => {
      if (typeof window === `undefined`) {
        return;
      }
      document.body.style.overflow = "unset";
      document.removeEventListener("keydown", closeByEsc);
    };
  }, []);

  return createPortal(
    <Theme>
      <StyledModalWrapper data-test-id={dataTestId}>
        <StyledModalBackdrop onClick={() => closeFunction()} />
        <StyledModalContent aria-label="modal" maxWidth={maxWidth}>
          {title && <StyledModalTitle>{title}</StyledModalTitle>}
          {children}
        </StyledModalContent>
      </StyledModalWrapper>
    </Theme>,
    document.getElementById("react-portal")
  );
};

export default Modal;
